import { useNavigate, useParams } from "react-router-dom";
import { useFetcher } from "~/hooks/useFetcher";
import { ROUTE_404 } from "~/router/constants";
import { CatalogTableEntity } from "~/types/interfaces/catalogResponse";

const { VITE_CATALOG_API } = import.meta.env;

const useDatasetTable = (fqn?: string) => {
  const navigate = useNavigate();
  // Only redirect to 404 when tableFQN came from the URL itself — callers
  // that pass `fqn` explicitly (e.g. the session context sidebar) are
  // embedded outside the /datasets/:datasetId/tables/:tableFQN route, so a
  // 4xx here should surface as an inline error rather than yanking the user
  // off their current page.
  const { tableFQN: routeTableFQN } = useParams();
  const tableFQN = routeTableFQN ?? fqn;

  const resp = useFetcher<CatalogTableEntity>(
    tableFQN ? `${VITE_CATALOG_API}/tables/fqn/${tableFQN}` : null,
    { shouldCamelize: true }
  );

  if (routeTableFQN && resp.error?.status >= 400 && resp.error.status < 500) {
    navigate(ROUTE_404, { replace: true });
  }

  return resp;
};

export default useDatasetTable;
